var React = require('react');

function Dropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M.2 7.5l2.9-2.8 8.9 8.9 8.9-8.9 2.9 2.8L12 19.3z"}));
}

Dropdown.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Dropdown;

Dropdown.default = Dropdown;
